<template>
  <div>
      <vs-card style="display: block;
                        margin: auto;
                        min-width: 350px;
                        max-width: 400px;
                        margin-top: 8%;
                        border-radius: 10px;">
          <div>
              <div class="p-2">
                  <div class="container-fluid">
                      <div class="row">
                          <div class="col-md-12">
                              <a href="/login" class="logo logo-admin">
                                  <img src="https://www.ausa.com.mx/img/Ausa-logov5.png" height="80" alt="logo"
                                       style="margin: auto; max-width: 200px !important;" />
                              </a>
                          </div>
                          <div class="col-md-12" style="top:30px;">
                              <h4 class="login-title-text" style="text-align:center;">Inicio de Sesión</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="p-2">
                  <form @submit.prevent="loginSuccess()" class="form-horizontal m-t-20" autocomplete="off">
                      <div class="container">
                          <!--<div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group row">
                          <vs-input style="width:300px;" :danger="errors.has('username')"
                            :danger-text="errors.has('username') ? errors.first('username') : ''" name="username"
                            data-vv-as="usuario" v-validate="'required|max:16'" type="text" label-placeholder="Usuario"
                            v-model.trim="user.username" />
                        </div>
                      </div>
                      <br>
                      <div class="col-md-6 col-sm-12" style="left:4px;">
                        <div class="form-group row">
                          <vs-input style="width:300px;" :danger="errors.has('password')"
                            :danger-text="errors.has('password') ? errors.first('password') : ''" name="password"
                            type="password" data-vv-as="contraseña" v-validate="'required'" label-placeholder="Contraseña"
                            autocomplete v-model.trim="user.password" />
                        </div>
                      </div>
                    </div>-->
                          <v-row>
                              <v-col cols="12" md="6">
                                  <div class="form-group row">
                                      <vs-input style="width:300px;" :danger="errors.has('username')"
                                                :danger-text="errors.has('username') ? errors.first('username') : ''" name="username"
                                                data-vv-as="usuario" v-validate="'required|max:16'" type="text" label-placeholder="Usuario"
                                                v-model.trim="user.username" />
                                  </div>
                              </v-col>
                              <v-col cols="12" md="6" style="left:4px;">
                                  <div class="form-group row">
                                      <vs-input style="width:300px;" :danger="errors.has('password')"
                                                :danger-text="errors.has('password') ? errors.first('password') : ''" name="password"
                                                type="password" data-vv-as="contraseña" v-validate="'required'" label-placeholder="Contraseña"
                                                autocomplete v-model.trim="user.password" />
                                  </div>
                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col>
                                  <div class="form-group row">
                                      <v-btn :loading="loading" class="ma-1" color="error" plain @click="RecuperarContrania">
                                          ¿Olvidaste tu contraseña?
                                      </v-btn>
                                  </div>
                              </v-col>
                          </v-row>
                      </div>
                      <div class="form-group text-center row m-t-20">
                          <div class="col-12">
                              <br>
                              <button class="vs-button-primary vs-button-filled btn-block vs-button"
                                      :disabled="user.username && user.password && !loggedIn ? false : true">
                                  <span v-show="!loggedIn">Iniciar Sesión</span>
                                  <div v-show="loggedIn" class="spinner-border spinner-border-sm" role="status">
                                      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                                           fill="none" viewBox="0 0 24 24">
                                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                          <path class="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                          </path>
                                      </svg>
                                      Procesando
                                  </div>
                              </button>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
          <div slot="footer" style="margin-top:-60px;">
              <vs-row vs-justify="center">
                  <p style="text-align:center; margin-bottom: 50px;" class="text-muted">
                  </p>
              </vs-row>
              <br>
          </div>
      </vs-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginService from "@/services/login/login.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Inicio from '@/services/main/main.service.js';
export default {
  data() {
    return {
      loggedIn: false,
      user: {
        username: "",
        password: ""
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["domain", 'informationPage'])
  },
  methods: {
    loginSuccess() {
      this.loggedIn = true;
      //  this.$validator.validateAll().then(response => {
      LoginService.verifyLogin(this.user).then(async response => {
        if (response.data == "") {
          ManagerLocalStorage.addSingleLocalStorage(this.user.username, this.informationPage.nameLocalStoragePGV2);
          let password = {
            tipo: 'OK',
            mensaje: null
          };
          let respuesta = await Inicio.ValidacionContraseña(this)/* .then(async response => { */
          if (respuesta.data[0].Mostrar == "True") {
            password = {
              tipo: 'PC',
              mensaje: respuesta.data[0].Mensaje
            }
          } else if (respuesta.data == "Obligatorio") {
            password = {
              tipo: 'O',
              mensaje: 'El tiempo para cambiar la contraseña ha expirado, deberá de restablecerla ahora.'
            }
          } else if (respuesta.data == "Nuevo") {
            password = {
              tipo: 'N',
              mensaje: 'Al ser la primera vez que ingresa deberá modificar su contraseña.'
            }
          }
          await MetodosGenerales.guardarEnSesionInfoReporte(password, 'password');
          this.$router.push({ name: `index`, params: { login: true, } });

          //window.location.href = this.domain.domainNameWithHttp;
        } else {
          this.$swal({
            position: "center",
            icon: "error",
            title: "Error al iniciar sesión",
            text: response.data,
            showConfirmButton: true,
            allowOutsideClick: false,
            timer: 7000,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
          this.loggedIn = false;
          this.user.password = "";
        }
      })
        .catch(error => {
          this.$swal({
            position: "center",
            icon: "error",
            title: "Hubo un problema al iniciar sesión",
            text: "Contactar al área de desarrollo.",
            showConfirmButton: true,
            allowOutsideClick: false,
            timer: 7000,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });

          this.loggedIn = false;
          this.user.password = "";
        });
      return;
    },
    RecuperarContrania() {
      this.loading = true;
      this.$router.push({ name: `Recuperar`, });
    }
  },
  mounted() {

    // LoginService.serviceWorkerStart();
    // ManagerLocalStorage.removeLocalStorage(this.informationPage.nameLocalStoragePGV2);
    MetodosGenerales.eliminaCookie(this.informationPage.nameCookiePGV2);
  }
};
</script>
<style scoped>
    .login-title-text {
        font-family: "Poppins", sans-serif;
        font-size: 18px;
        font-weight: 900;
        margin-bottom: 0px;
        color: #757575 !important;
    }
</style>
